import React, { Component } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import Loader from "../utils/Loader";
import { Modal } from "react-bootstrap";
import moment from 'moment';
import { connect } from "react-redux";
import $ from 'jquery';
import { countDownDateUrl, toastError } from '../utils/constants';
import { axiosGet } from '../react_axios/Axios';
import { withRouter } from '../utils/withRouter';
import { getCmsContent_action } from '../actions/cms_action/cmsAction';
import { getCartList_action } from '../actions/userAction/cart_action';

class NewHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user_id: localStorage.getItem("user_id"),
            role_id: localStorage.getItem("role_id"),
            isLoading: false,
            scrollPosition: 0,
            isOpen: false,
            isCommingSoon: false,
            timeLeft: {},
            intervalId: null,
            popMsg: null,
            popDetails: {},
            currentPage: null,
            headerNavs: [],
            cmsMode: '',
            isHome: false,
            cartItemCount: 0,
            cartList: [], // Added cartList to state
            isPgButton: sessionStorage.getItem('isPgButton') || '0'
        };
    }

    componentDidMount() {
        // Initialize cart count from sessionStorage first
        this.initializeCartCount();

        // Only fetch cart data if user is logged in and required data exists
        const userIdSS = sessionStorage.getItem("UserIDSS");
        const loginDataSS = sessionStorage.getItem("loginDataSS");

        if (userIdSS && loginDataSS) {
            // Add a small delay to ensure session storage is fully populated
            setTimeout(() => {
                this.getCartData();
            }, 100);
        }

        // Scroll listener
        this.handleScroll = () => {
            this.setState({ scrollPosition: window.scrollY });
        };

        console.log(this.props.headerNavs, 'headerNavs')
        if (Array.isArray(this.props.headerNavs) && this.props.headerNavs.length > 0) {
            this.setState({ headerNavs: this.props.headerNavs })
        } else {
            const urlPath = this.props.location.pathname;

            if (urlPath) {
                // Remove /cms/manage/ if present
                const cleanPath = urlPath.replace(/^\/cms\/manage\//, '').replace(/^\/+|\/+$/g, '');
                const parts = cleanPath.split('&');

                if (parts.length === 2) {
                    const MenuUrl = parts[0];
                    const MenuID = parts[1];
                    console.log('if header');
                    this.getCmsContent(MenuID, MenuUrl);
                } else {
                    console.log('else header');
                    // If no & found, use cleanPath as MenuUrl
                    this.getCmsContent(1, cleanPath || 'home');
                }
            } else {
                console.log('else header');
                this.getCmsContent(1, 'home');
            }
        }

        const path = this.props.location.pathname;
        if (path == '/') {
            this.setState({ isHome: true })
        }

        const cmsPrefix = '/cms';
        if (path.includes(cmsPrefix)) {
            this.setState({ cmsMode: 1 })
        } else {
            this.setState({ cmsMode: 0 })
        }

        window.addEventListener('scroll', this.handleScroll);

        // jQuery click handlers
        $(document).ready(function () {
            $(".offcanvas__close, .offcanvas__overlay, .navigate__close").on("click", function () {
                $(".offcanvas__info").removeClass("info-open");
                $(".offcanvas__overlay").removeClass("overlay-open");
            });

            $(".sidebar__toggle").on("click", function () {
                $(".offcanvas__info").addClass("info-open");
                $(".offcanvas__overlay").addClass("overlay-open");
            });

            $(".body-overlay").on("click", function () {
                $(".offcanvas__area").removeClass("offcanvas-opened");
                $(".df-search-area").removeClass("opened");
                $(".body-overlay").removeClass("opened");
            });

            $('#mobile-menu-toggle').on('click', function () {
                $('#mobile-menu').toggleClass('open');
            });
        });
    }

    componentDidUpdate(prevProps, prevState) {
        // Check if login status changed based on user_id
        const wasLoggedIn = prevState.user_id !== null;
        const isLoggedIn = this.state.user_id !== null;

        if (!wasLoggedIn && isLoggedIn) {
            // User just logged in, fetch cart data
            this.getCartData();
        } else if (wasLoggedIn && !isLoggedIn) {
            // User just logged out, clear cart data
            this.setState({ cartItemCount: 0, cartList: [] });
            sessionStorage.removeItem("cartItems");
        }

        // Also check for changes in session storage values
        const currentUserIdSS = sessionStorage.getItem("UserIDSS");
        const prevUserIdSS = this.prevUserIdSS;

        if (currentUserIdSS !== prevUserIdSS) {
            this.prevUserIdSS = currentUserIdSS;
            if (currentUserIdSS && sessionStorage.getItem("loginDataSS")) {
                this.getCartData();
            }
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
        // Clear any running intervals
        if (this.state.intervalId) {
            clearInterval(this.state.intervalId);
        }
    }

    // Initialize cart count from sessionStorage
    initializeCartCount = () => {
        const cartItems = sessionStorage.getItem("cartItems");
        if (cartItems) {
            try {
                const count = parseInt(cartItems) || 0;
                this.setState({ cartItemCount: count });
            } catch (error) {
                console.error("Error parsing cart items:", error);
                this.setState({ cartItemCount: 0 });
            }
        }
    }

    // Method to refresh cart data when needed
    refreshCartData = () => {
        if (sessionStorage.getItem("UserIDSS") && sessionStorage.getItem("loginDataSS")) {
            this.getCartData();
        } else {
            this.setState({ cartItemCount: 0, cartList: [] });
            sessionStorage.removeItem("cartItems");
        }
    }

    getCmsContent = async (MenuID, MenuUrl) => {
        try {
            this.setState({ isLoading: true });

            const data = await this.props.getCmsContent_action(MenuID ? MenuID : 1, MenuUrl ? MenuUrl : 'home');
            if (data.error !== 1) {
                const isPgButtonValue = data?.data[6] !== '' ? data?.data[6]?.[0]?.value : '0';

                this.setState({
                    isLoading: false,
                    cmsMenuData: data?.data[1] !== "" ? data?.data[1] : [],
                    headerNavs: data?.data[1] !== "" ? data?.data[1] : [],
                    isPgButton: isPgButtonValue
                }, () => {
                    sessionStorage.setItem('isPgButton', isPgButtonValue);
                });
            } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }

    handleMenuClick(MenuID, Url) {
        localStorage.setItem("MenuID", MenuID);
        localStorage.setItem("Url", Url);

        const trimmedUrl = Url.trim();
        const externalUrlPattern = /^(https?:\/\/|www\.|ftp:\/\/|mailto:)/i;

        if (externalUrlPattern.test(trimmedUrl)) {
            window.open(trimmedUrl, '_blank');
        } else {
            const normalizedUrl = trimmedUrl.startsWith('/') ? trimmedUrl : '/' + trimmedUrl;
            const basePath = this.props.location.pathname.includes('/cms') ? '/cms/manage' : '';
            const newPath = `${basePath}${normalizedUrl}&${MenuID}`

            this.props.navigate(newPath);
        }
    }

    onLogout() {
        sessionStorage.clear();
        localStorage.clear();
        this.setState({
            cartItemCount: 0,
            cartList: [],
            user_id: null
        });
        this.props.navigate('/')
    }

    navLogin() {
        sessionStorage.setItem("isLoginClicked", true)
        this.props.navigate('/login')
    }

    calculateTimeLeft(LaunchDate) {
        const { intervalId } = this.state
        const targetDate = moment.utc(LaunchDate);
        const currentDate = moment();
        const split = currentDate.format().split('+')
        const updateCurrentDate = split[0] + 'Z'
        const totalSeconds = targetDate.diff(updateCurrentDate, 'seconds');
        const days = Math.floor(totalSeconds / (60 * 60 * 24));
        const hours = Math.floor((totalSeconds % (60 * 60 * 24)) / (60 * 60));
        const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
        const seconds = totalSeconds % 60;

        if (days === 0 && hours === 0 && minutes === 0 && seconds === 0) {
            if (intervalId) {
                clearInterval(intervalId);
                this.setState({ intervalId: null })
            }
            const navigateTo = sessionStorage.getItem('navigateTo');
            if (navigateTo) {
                this.props.navigate(navigateTo);
                if (navigateTo === '/companyProfile') {
                    sessionStorage.setItem('currentPage', 'companyProfile');
                    this.setState({ currentPage: 'companyProfile' })
                }
                sessionStorage.removeItem('navigateTo');
            }
            this.setState({ isopen: false })
        }
        return {
            days: days < 10 ? `0${days}` : days,
            hours: hours < 10 ? `0${hours}` : hours,
            minutes: minutes < 10 ? `0${minutes}` : minutes,
            seconds: seconds < 10 ? `0${seconds}` : seconds,
        };
    };

    callCountDown = async (navigateTo) => {
        this.setState({ isLoading: true })
        try {
            const mapData = {};
            const response = await axiosGet(countDownDateUrl, mapData);
            if (response) {
                if (response.data != []) {
                    const LaunchDate = response.data[0]['countDownDate']
                    const targetDate = moment.utc(LaunchDate);
                    const currentDate = moment();
                    const split = currentDate.format().split('+')
                    const updateCurrentDate = split[0] + 'Z'
                    const totalSeconds = targetDate.diff(updateCurrentDate, 'seconds');

                    const array = LaunchDate != null && this.formatDate(LaunchDate);
                    if (totalSeconds >= 0) {
                        this.setState({ isCommingSoon: false })
                        const timer = setInterval(async () => {
                            this.setState({ timeLeft: this.calculateTimeLeft(LaunchDate) });
                            sessionStorage.setItem("navigateTo", navigateTo)
                            this.setState({
                                popDetails: array,
                                popMsg: 'registration',
                                isOpen: true,
                                isLoading: false
                            })

                        }, 1000);
                        this.setState({ intervalId: timer })
                        return () => clearInterval(timer);
                    } else {
                        this.setState({ isLoading: false, isCommingSoon: true })
                        this.props.navigate(navigateTo)
                        sessionStorage.removeItem('navigateTo');
                    }
                } else {
                    this.setState({ isLoading: false })
                }
            } else {
                console.error("Failed to fetch dashboard log: No data found.");
            }
        } catch (error) {
            console.error("Error fetching dashboard log:", error);
        }
    }

    callEnquiryDate = async (navigateTo) => {
        this.setState({ isLoading: true })
        try {
            const mapData = {};
            const response = await axiosGet(countDownDateUrl, mapData);
            if (response) {
                if (response.data != []) {
                    const LaunchDate = response.data[0]['enquiryDate']
                    const targetDate = moment.utc(LaunchDate);
                    const currentDate = moment();
                    const split = currentDate.format().split('+')
                    const updateCurrentDate = split[0] + 'Z'
                    const totalSeconds = targetDate.diff(updateCurrentDate, 'seconds');
                    const array = LaunchDate != null && this.formatDate(LaunchDate);
                    if (totalSeconds >= 0) {
                        this.setState({ isCommingSoon: false })
                        const timer = setInterval(async () => {
                            this.setState({ timeLeft: this.calculateTimeLeft(LaunchDate) });
                            sessionStorage.setItem("navigateTo", navigateTo);
                            this.setState({ popDetails: array, popMsg: 'enquiry', isOpen: true, isLoading: false })
                        }, 1000);
                        this.setState({ intervalId: timer })
                        return () => clearInterval(timer);
                    } else {
                        this.setState({ isLoading: false, isCommingSoon: true })
                        this.props.navigate(navigateTo)
                        sessionStorage.removeItem('navigateTo');
                    }
                } else {
                    this.setState({ isLoading: false })
                }
            } else {
                console.error("Failed to fetch dashboard log: No data found.");
            }
        } catch (error) {
            console.error("Error fetching dashboard log:", error);
        }
    }

    callLoginDate = async (navigateTo) => {
        this.setState({ isLoading: true })
        try {
            const mapData = {};
            const response = await axiosGet(countDownDateUrl, mapData);
            if (response) {
                if (response.data != []) {
                    const LaunchDate = response.data[0]['loginDate']
                    const targetDate = moment.utc(LaunchDate);
                    const currentDate = moment();
                    const split = currentDate.format().split('+')
                    const updateCurrentDate = split[0] + 'Z'
                    const totalSeconds = targetDate.diff(updateCurrentDate, 'seconds');
                    const array = LaunchDate != null && this.formatDate(LaunchDate);

                    if (totalSeconds >= 0) {
                        this.setState({ isCommingSoon: false })
                        const timer = setInterval(async () => {
                            this.setState({ timeLeft: this.calculateTimeLeft(LaunchDate) });
                            sessionStorage.setItem("navigateTo", navigateTo);
                            this.setState({ popDetails: array, popMsg: 'login', isOpen: true, isLoading: false })
                        }, 1000);
                        this.setState({ intervalId: timer })
                        return () => clearInterval(timer);
                    } else {
                        this.setState({ isLoading: false, isCommingSoon: true })
                        this.props.navigate(navigateTo)
                        sessionStorage.removeItem('navigateTo');
                    }
                } else {
                    this.setState({ isLoading: false })
                }
            } else {
                console.error("Failed to fetch dashboard log: No data found.");
            }
        } catch (error) {
            console.error("Error fetching dashboard log:", error);
        }
    }

    // Updated getCartData with better error handling and conditional checks
    getCartData = () => {
        const userIdSS = sessionStorage.getItem("UserIDSS");
        const loginDataSS = sessionStorage.getItem("loginDataSS");

        if (!userIdSS || !loginDataSS) {
            console.log("Required session data not available for cart fetch");
            this.setState({ cartItemCount: 0 });
            return;
        }

        let memberID;
        try {
            memberID = JSON.parse(loginDataSS)?.MemberID;
        } catch (error) {
            console.error("Error parsing login data:", error);
            this.setState({ cartItemCount: 0 });
            return;
        }

        if (!memberID) {
            console.log("Member ID not found in login data");
            this.setState({ cartItemCount: 0 });
            return;
        }

        this.setState({ isLoading: true });

        this.props
            .getCartList_action(userIdSS, memberID)
            .then((data) => {
                if (data.error !== 1) {
                    const cartItems = data.data[0] || [];
                    // Auto-check all items on load
                    const updatedList = cartItems.map(item => ({ ...item, isChecked: true }));

                    sessionStorage.setItem("cartItems", updatedList.length.toString());

                    this.setState({
                        isLoading: false,
                        cartList: updatedList,
                        cartItemCount: updatedList.length,
                        isAllChecked: true,
                        checkBoxFlag: updatedList.length > 0,
                        selectedPIList: updatedList,
                        showEligibilityButton: updatedList.length > 0 &&
                            (this.state.RedemptionStageStatusID == null || this.state.RedemptionStageStatusID == undefined),
                    });
                } else {
                    this.setState({
                        isLoading: false,
                        cartItemCount: 0,
                        cartList: []
                    });
                    if (data.data && data.data.ErrorMsg) {
                        toastError(data.data.ErrorMsg);
                    }
                }
            })
            .catch((e) => {
                console.error("Cart fetch error:", e);
                this.setState({
                    isLoading: false,
                    cartItemCount: 0,
                    cartList: []
                });
                toastError("Failed to fetch cart data.");
            });
    }

    formatDate(dateString) {
        const dateObj = new Date(dateString);
        console.log("dateObj--->", dateObj)
        const date = dateObj.getUTCDate();
        const month = dateObj.toLocaleString('en-US', { month: 'long', timeZone: 'UTC' });
        const year = dateObj.getUTCFullYear();
        const time = dateObj.toISOString().split('T')[1].slice(0, 5);

        function getOrdinalSuffix(day) {
            if (day > 3 && day < 21) return "th";
            switch (day % 10) {
                case 1: return "st";
                case 2: return "nd";
                case 3: return "rd";
                default: return "th";
            }
        }
        return { date, month, year, time, pronounce: getOrdinalSuffix(date) };
    }

    render() {
        const {
            popDetails, popMsg, timeLeft, isLoading, isOpen, isCommingSoon,
            currentPage, intervalId, headerNavs, cmsMode, isHome,
            cartItemCount, isPgButton
        } = this.state;

        const loginAccessList = JSON.parse(sessionStorage.getItem('loginAccesslist'));

        const hasAccess = (moduleName) => {
            const module = loginAccessList?.find(mod => mod.ModuleName === moduleName);
            return module && (module.ReadAccess || module.WriteAccess || module.UpdateAccess || module.DeleteAccess || module.DownloadAccess || module.FullAccess || module.Is_SpecialAccess || module.SendAccess);
        };

        const menuItems = [
            { name: "Member Dashboard", path: "/memberDashboard", DisplayName: 'Dashboard' },
            { name: "Role List", path: "/role_list", DisplayName: 'Role' },
            { name: "User List", path: "/user_list", DisplayName: 'User' },
            { name: "Accumulating Points List", path: "/accumulating_list", DisplayName: 'Accumulating Points' },
            { name: "Redemption Points List", path: "/redemption_list", DisplayName: 'Redemption Points' },
            { name: "User Accumulation List", path: "/user_accum_list", DisplayName: 'User Accumulated List' },
            { name: "User Redeemed List", path: "/user_redeemed_list", DisplayName: 'User Redeemed List' },
            { name: "Redemption Requests", path: "/redemption_requests_list", DisplayName: 'Redemption Requests' },
            { name: "Receipt List", path: "/receiptList", DisplayName: 'Receipt' },
            { name: "Proforma List", path: "/proforma_list", DisplayName: 'Proforma' },
            { name: "Tax Invoice List", path: "/taxInvoice_list", DisplayName: 'Tax Invoice' },
            { name: "Event Master", path: "/event_master_list", DisplayName: 'Event Master' },
            { name: "Enquiry List", path: "/enquiry_list", DisplayName: 'Enquiry List' },
            { name: "Event Enquiry List", path: "/event_enquiry_list", DisplayName: 'Event Enquiry List' },
            { name: "Profile", path: "/user_details", DisplayName: 'Profile' },
            { name: "Benefits", path: "/benefits_list", DisplayName: 'Benefits' },
            { name: "Promo Code List", path: "/promocode_list", DisplayName: 'Promo Code' },
            { name: "Blog", path: "/blogList", DisplayName: 'Blog' },
            { name: "Master", path: "/master_list", DisplayName: 'Master' },
            { name: "Reports", path: "/reportList", DisplayName: 'Reports' },
        ];
        const roleId = Number(localStorage.getItem('role_id'));
        const accessibleMenuItems = roleId === 1 ? menuItems?.filter(item => item.name !== 'Profile') : menuItems?.filter(item => hasAccess(item.name));
        const filteredNavs = headerNavs?.filter(item => item.isActive && item.isPublish);
        const parents = filteredNavs?.filter(item => item.ParentID === null);
        const childrenMap = {};

        filteredNavs?.forEach(item => {
            if (item.ParentID !== null) {
                if (!childrenMap[item.ParentID]) childrenMap[item.ParentID] = [];
                childrenMap[item.ParentID].push(item);
            }
        });

        return (
            <>
                {isLoading ? (<Loader></Loader>) : (null)}
                <>
                    <div className="fix-area">
                        <div className="offcanvas__info">
                            <div className="offcanvas__wrapper">
                                <div className="offcanvas__content">
                                    <div className="offcanvas__top d-flex justify-content-between align-items-center">
                                        <div className="offcanvas__logo">
                                            <a onClick={() => this.props.navigate('/')}>
                                                <img src="assets/img/logo_text_color.png" alt="logo-img" />
                                            </a>
                                        </div>
                                        <div className="offcanvas__close">
                                            <button><i className="fa fa-times" /></button>
                                        </div>
                                    </div>
                                    <p className="text d-none d-lg-block">
                                        Nullam dignissim, ante scelerisque the is euismod fermentum odio sem
                                        semper the is erat, a feugiat leo urna eget eros. Duis Aenean a
                                        imperdiet risus.
                                    </p>
                                    <div className="mobile-menu fix mb-3" />
                                    <ul style={{ color: 'rebeccapurple' }}>
                                        {(() => {
                                            const internalPages = [];

                                            return parents?.sort((a, b) => a.Sequence - b.Sequence)?.map((parent, index) => {
                                                const hasChildren = childrenMap[parent.MenuID]?.length > 0;
                                                const children = childrenMap[parent.MenuID]?.sort((a, b) => a.Sequence - b.Sequence) || [];
                                                const showParent = parent.isMenuItem || (cmsMode && !parent.isMenuItem);
                                                const visibleChildren = children.filter(child => child.isMenuItem || cmsMode);

                                                // Collect non-menu items for Internal Pages
                                                if (cmsMode) {
                                                    if (!parent.isMenuItem) {
                                                        internalPages.push({ ...parent, isChild: false });
                                                    }
                                                    children.forEach(child => {
                                                        if (!child.isMenuItem) {
                                                            internalPages.push({ ...child, isChild: true, parentTitle: parent.Title });
                                                        }
                                                    });
                                                }

                                                if (!showParent && visibleChildren.length === 0) {
                                                    return null;
                                                }

                                                const isSecondLast = index === parents.length - 1;

                                                if (isSecondLast) {
                                                    return (
                                                        <React.Fragment key={parent.MenuID}>
                                                            <li><a>Registration <i className="fa fa-angle-down"></i></a>
                                                                <ul className="submenu">
                                                                    {sessionStorage.getItem('loginDataSS') == null && (
                                                                        <li onClick={() => this.props.navigate('/companyProfile')}><a>Register Now</a></li>
                                                                    )}
                                                                    <li onClick={() => this.props.navigate('/enquiryForm')}><a>Enquiry</a></li>
                                                                    <li onClick={() => this.props.navigate('/RegisteredList')}><a>Registered Organisations</a></li>
                                                                </ul>
                                                            </li>
                                                            {hasChildren ? (
                                                                <li>
                                                                    <div className="faq-accordion mt-md-0">
                                                                        <div className="accordion" id="accordion">
                                                                            <div className="accordion-item responsive-border-0 mb-1">
                                                                                <h5 className="accordion-header">
                                                                                    <button className="accordion-button responsive-btn p-2 py-1 collapsed"
                                                                                        type="button" data-bs-toggle="collapse"
                                                                                        data-bs-target="#About" aria-expanded="false"
                                                                                        aria-controls="About">{parent.Title}</button>
                                                                                </h5>
                                                                                <div id="About" className="accordion-collapse collapse" data-bs-parent="#accordion">
                                                                                    <div className="accordion-body p-2">
                                                                                        <ul className="submenu">
                                                                                            {visibleChildren.map(child => (
                                                                                                <li key={child.MenuID}>
                                                                                                    <a onClick={() => this.handleMenuClick(child.MenuID, child.Url)}>{child.Title}</a>
                                                                                                </li>
                                                                                            ))}
                                                                                        </ul>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            ) : (
                                                                <li className="has-dropdown active menu-thumb res-padding">
                                                                    <a onClick={() => this.handleMenuClick(parent.MenuID, parent.Url)}>{parent.Title}</a>
                                                                </li>
                                                            )}
                                                        </React.Fragment>
                                                    );
                                                }

                                                return hasChildren ? (
                                                    <li key={parent.MenuID}>
                                                        <a>{parent.Title} <i className="fa fa-angle-down"></i></a>
                                                        <ul className="submenu">
                                                            {visibleChildren.map(child => (
                                                                <li key={child.MenuID}>
                                                                    <a onClick={() => this.handleMenuClick(child.MenuID, child.Url)}>{child.Title}</a>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </li>
                                                ) : (
                                                    <li key={parent.MenuID} className="has-dropdown active menu-thumb menu-padding-res">
                                                        <a onClick={() => this.handleMenuClick(parent.MenuID, parent.Url)}>{parent.Title}</a>
                                                    </li>
                                                );
                                            }).concat(
                                                // Add Internal Pages section if needed
                                                cmsMode && internalPages.length > 0 ? (
                                                    <li key="internal-pages" className="has-dropdown active menu-thumb menu-padding-res">
                                                        <a>Internal Pages <i className="fa fa-angle-down"></i></a>
                                                        <ul className="submenu">
                                                            {internalPages.map(page => (
                                                                <li key={page.MenuID}>
                                                                    <a onClick={() => this.handleMenuClick(page.MenuID, page.Url)}>
                                                                        {page.isChild ? `${page.parentTitle} - ${page.Title}` : page.Title}
                                                                    </a>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </li>
                                                ) : null
                                            );
                                        })()}

                                        {sessionStorage.getItem('loginDataSS') != null ?
                                            <>
                                                <li>
                                                    <div className="faq-accordion mt-md-0">
                                                        <div className="accordion" id="accordion">
                                                            <div className="accordion-item responsive-border-0 mb-1">
                                                                <h5 className="accordion-header">
                                                                    <button className="accordion-button responsive-btn p-2 py-1 collapsed"
                                                                        type="button" data-bs-toggle="collapse" data-bs-target="#News_PR"
                                                                        aria-expanded="false" aria-controls="News_PR">CMS</button>
                                                                </h5>
                                                                <div id="News_PR" className="accordion-collapse collapse" data-bs-parent="#accordion">
                                                                    <div className="accordion-body p-2">
                                                                        <ul className="submenu">
                                                                            <li onClick={() => this.props.navigate('/cms/manage')}><a>Switch to Editor Mode</a></li>
                                                                            <li onClick={() => this.props.navigate('/cms/header')}><a>Menu Settings</a></li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="faq-accordion mt-md-0">
                                                        <div className="accordion" id="accordion">
                                                            <div className="accordion-item responsive-border-0 mb-1">
                                                                <h5 className="accordion-header">
                                                                    <button className="accordion-button responsive-btn p-2 py-1 collapsed"
                                                                        type="button" data-bs-toggle="collapse" data-bs-target="#Setting"
                                                                        aria-expanded="false" aria-controls="Setting">Settings</button>
                                                                </h5>
                                                                <div id="Setting" className="accordion-collapse collapse" data-bs-parent="#accordion">
                                                                    <div className="accordion-body p-2">
                                                                        <ul className="submenu">
                                                                            {(JSON.parse(sessionStorage.getItem('loginDataSS')).RoleName == 'Super Admin' || JSON.parse(sessionStorage.getItem('loginDataSS')).RoleName == 'Admin') ? <>
                                                                                <li onClick={() => this.props.navigate('/role_list')}><a>Role</a></li>
                                                                                <li onClick={() => this.props.navigate('/user_list')}><a>User</a></li>
                                                                                <li onClick={() => this.props.navigate('/receiptList')}><a>Receipt</a></li>
                                                                                <li onClick={() => this.props.navigate('/proforma_list')}><a>Proforma</a></li>
                                                                                <li onClick={() => this.props.navigate('/taxInvoice_list')}><a>Tax Invoice</a></li>
                                                                                <li onClick={() => this.props.navigate('/enquiry_list')}><a>Enquiry List</a></li>
                                                                            </> : JSON.parse(sessionStorage.getItem('loginDataSS')).RoleName == 'User' ? <>
                                                                                <li onClick={() => this.props.navigate('/user_details')}><a>Profile</a></li>
                                                                                <li onClick={() => this.props.navigate('/receiptList')}><a>Receipt</a></li>
                                                                                <li onClick={() => this.props.navigate('/proforma_list')}><a>Proforma</a></li>
                                                                                <li onClick={() => this.props.navigate('/taxInvoice_list')}><a>Tax Invoice</a></li>
                                                                                <li onClick={() => this.props.navigate('/benefits_list')}><a>Benefits</a></li>
                                                                            </> : <></>}
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <ul className="submenu">
                                                        <li><a>{JSON.parse(sessionStorage.getItem('loginDataSS')).CompanyName}</a></li>
                                                        <li className='mt-3'>
                                                            <a onClick={() => this.props.navigate('/changePassword')} className="gt-mobile-btn">
                                                                <span>Change Password &nbsp;<i className="fa fa-arrow-right-long"></i></span>
                                                            </a>
                                                        </li>
                                                        <li className='mt-3'>
                                                            <a onClick={() => this.onLogout()} className="gt-mobile-btn"><span> Logout &nbsp;<i className="fa fa-arrow-right-long"></i></span></a>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </> : <li className='mt-3'>
                                                <a onClick={() => {
                                                    this.navLogin();
                                                }} className="gt-mobile-btn navigate__close">
                                                    <span>Login &nbsp;<i className="fa fa-arrow-right-long"></i></span>
                                                </a>
                                            </li>}
                                    </ul>
                                    <div className="offcanvas__contact">
                                        <h4>Contact Info</h4>
                                        <ul className='m-0'>
                                            <li className="d-flex align-items-center">
                                                <div className="offcanvas__contact-icon"><i className="fa fa-map-marker"></i></div>
                                                <div className="offcanvas__contact-text">
                                                    <a>1210/1211/1212 Dalamal Tower, 'A' Wing, 12th Floor, Plot No.211, Nariman Point, Mumbai – 400 021, INDIA</a>
                                                </div>
                                            </li>
                                            <li className="d-flex align-items-center">
                                                <div className="offcanvas__contact-icon mr-15"><i className="fa fa-envelope" /></div>
                                                <div className="offcanvas__contact-text">
                                                    <a href="mailto:info@azent.com">
                                                        <span className="mailto:business.desk@india-itme.com">business.desk@india-itme.com</span>
                                                    </a>
                                                </div>
                                            </li>
                                            <li className="d-flex align-items-center">
                                                <div className="offcanvas__contact-icon mr-15"><i className="fa fa-clock" /></div>
                                                <div className="offcanvas__contact-text">
                                                    <a target="_blank" href="#">Mod-friday, 10:00 am to 06:00 pm</a>
                                                </div>
                                            </li>
                                            <li className="d-flex align-items-center">
                                                <div className="offcanvas__contact-icon mr-15"><i className="fa fa-phone" /></div>
                                                <div className="offcanvas__contact-text"><a>+91-22-4972 4603 / 2202 0032 / 2285 1579</a></div>
                                            </li>
                                        </ul>
                                        <div className="social-icon d-flex pb-3 align-items-center">
                                            <a target='blank' href="https://www.facebook.com/indiaitmesociety"><i className="fa fa-facebook-f"></i></a>
                                            <a target='blank' href="https://www.linkedin.com/company/india-itme"><i className="fa fa-linkedin"></i></a>
                                            <a target='blank' href="https://www.youtube.com/c/IndiaITMESociety"><i className="fa fa-youtube-play"></i></a>
                                            <a target='blank' href="https://www.instagram.com/indiaitme"><i className="fa fa-instagram"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="offcanvas__overlay" />
                </>
                <header>
                    <div id="header-sticky"
                        className={`header-4 ${isHome && window.scrollY > 150 ? "sticky" : ""}`}
                        style={{
                            position: "fixed",
                            marginTop: isHome ? (window.scrollY > 250 ? '0px' : '30px') : '0px',
                            top: 0,
                            width: "100%",
                            zIndex: 1000,
                            transition: "background 0.3s ease",
                            background: isHome ? (window.scrollY > 250 ? '#744587' : 'transparent') : '#744587',
                            boxShadow: isHome ? (window.scrollY > 250 ? '0 4px 6px rgba(0, 0, 0, 0.1)' : 'none') : '0 4px 6px rgba(0, 0, 0, 0.1)'
                        }}
                    >
                        <div className="container">
                            <div className="mega-menu-wrapper">
                                <div className="header-main">
                                    <div className="header-left">
                                        <div className="logo">
                                            <a onClick={() => this.props.navigate('/')} className="header-logo">
                                                <img src="assets/img/logo_white.png" alt="logo-img" className="logo_img" />
                                            </a>
                                        </div>
                                    </div>
                                    <div className="header-middle">
                                        <div className="mean__menu-wrapper">
                                            <div className="main-menu">
                                                <nav id="mobile-menu">
                                                    <ul>
                                                        {(() => {
                                                            // Filter only parents where isMenuItem is true or cmsMode is false
                                                            const filteredParents = parents?.filter(parent => parent.isMenuItem);

                                                            // Filter Internal Pages where isMenuItem is false and cmsMode is true
                                                            const internalPages = parents?.filter(parent => !parent.isMenuItem && cmsMode);
                                                            const showInternalPages = cmsMode && internalPages && internalPages.length > 0;

                                                            return (
                                                                <>
                                                                    {/* Normal Menu Rendering */}
                                                                    {filteredParents?.sort((a, b) => a.Sequence - b.Sequence)?.map((parent, index) => {
                                                                        const hasChildren = childrenMap[parent.MenuID]?.length > 0;
                                                                        const isSecondLast = index === filteredParents.length - 1;
                                                                        return (
                                                                            <React.Fragment key={parent.MenuID}>
                                                                                {isSecondLast && (
                                                                                    <li>
                                                                                        <a>Registration <i className="fa fa-angle-down"></i></a>
                                                                                        <ul className="submenu">
                                                                                            {sessionStorage.getItem('loginDataSS') == null && (
                                                                                                <li onClick={() => this.props.navigate('/companyProfile')}>
                                                                                                    <a>Register Now</a>
                                                                                                </li>
                                                                                            )}
                                                                                            <li onClick={() => this.props.navigate('/enquiryForm')}>
                                                                                                <a>Enquiry</a>
                                                                                            </li>
                                                                                            <li onClick={() => this.props.navigate('/RegisteredList')}>
                                                                                                <a>Registered Organisations</a>
                                                                                            </li>
                                                                                        </ul>
                                                                                    </li>
                                                                                )}

                                                                                {hasChildren ? (
                                                                                    <li>
                                                                                        <a>{parent.Title} <i className="fa fa-angle-down"></i></a>
                                                                                        <ul className="submenu">
                                                                                            {childrenMap[parent.MenuID]
                                                                                                ?.filter(child => child.isMenuItem) // Ensure only items with isMenuItem: true
                                                                                                ?.map(child => (
                                                                                                    <li key={child.MenuID}>
                                                                                                        <a onClick={() => this.handleMenuClick(child.MenuID, child.Url)}>{child.Title}</a>
                                                                                                    </li>
                                                                                                ))}
                                                                                        </ul>
                                                                                    </li>
                                                                                ) : (
                                                                                    <li className="has-dropdown active menu-thumb menu-padding-res">
                                                                                        <a onClick={() => this.handleMenuClick(parent.MenuID, parent.Url)}>{parent.Title}</a>
                                                                                    </li>
                                                                                )}
                                                                            </React.Fragment>
                                                                        );
                                                                    })}

                                                                    {/* Internal Pages Handling */}
                                                                    {showInternalPages ? (
                                                                        <li>
                                                                            <a>Internal Pages <i className="fa fa-angle-down"></i></a>
                                                                            <ul className="submenu">
                                                                                {internalPages?.map(parent => (
                                                                                    <li key={parent.MenuID}>
                                                                                        <a onClick={() => this.handleMenuClick(parent.MenuID, parent.Url)}>{parent.Title}</a>
                                                                                    </li>
                                                                                ))}
                                                                                {Object.values(childrenMap)
                                                                                    .flat()
                                                                                    ?.filter(child => !child.isMenuItem) // Ensure only items with isMenuItem: false
                                                                                    ?.map(child => (
                                                                                        <li key={child.MenuID}>
                                                                                            <a onClick={() => this.handleMenuClick(child.MenuID, child.Url)}>{child.Title}</a>
                                                                                        </li>
                                                                                    ))}
                                                                            </ul>
                                                                        </li>
                                                                    ) : <></>}
                                                                </>
                                                            );
                                                        })()}
                                                        {sessionStorage.getItem('loginDataSS') != null ? <>
                                                            {sessionStorage.getItem('RoleIDSS') == 1 ? <>
                                                                <li><a>CMS <i className="fa fa-angle-down"></i></a>
                                                                    <ul className="submenu">
                                                                        <li onClick={() => this.props.navigate('/cms/manage')}><a>Switch to Editor Mode</a></li>
                                                                        <li onClick={() => this.props.navigate('/cms/header')}><a>Menu Settings</a></li>
                                                                    </ul>
                                                                </li>
                                                            </> : <></>}
                                                        </> : <></>}
                                                    </ul>
                                                </nav>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="header-right d-flex justify-content-end align-items-center">
                                        {sessionStorage.getItem('loginDataSS') != null ? <>
                                            <div className="mean__menu-wrapper">
                                                <div className="main-menu">
                                                    <nav id="mobile-menu">
                                                        <ul className='d-flex'>
                                                            {accessibleMenuItems.length > 0 && (
                                                                <li><a><i className="fa fa-cog"></i></a>
                                                                    <ul className="submenu header-right" style={{ maxHeight: '20rem', overflowY: 'scroll' }}>
                                                                        {accessibleMenuItems.map((item, index) => (
                                                                            <li key={index} onClick={() => this.props.navigate(item.path)}>
                                                                                <a>{item.DisplayName}</a>
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                </li>
                                                            )}
                                                            {isPgButton == '1' ? <>
                                                                {JSON.parse(sessionStorage.getItem('loginDataSS'))?.RoleName == 'User' &&
                                                                    <li className="profile_li" onClick={() => this.props.navigate('/cart')}>
                                                                        <a className="cartIcon_class" title='Cart'>
                                                                            <i className="fa fa-shopping-cart" aria-hidden="true"></i>
                                                                        </a>
                                                                        {cartItemCount > 0 &&
                                                                            <div className="card_badge">{cartItemCount}</div>
                                                                        }
                                                                    </li>
                                                                }
                                                            </> : <></>}
                                                            <li>
                                                                <a><i className="fa fa-regular fa-user"></i></a>
                                                                <ul className="submenu header-right">
                                                                    <li><a>{JSON.parse(sessionStorage.getItem('loginDataSS')).CompanyName}</a></li>
                                                                    <li onClick={() => this.props.navigate('/changePassword')}><a>Change Password</a></li>
                                                                    <li onClick={() => this.onLogout()}><a>Logout</a></li>
                                                                </ul>
                                                            </li>
                                                        </ul>
                                                    </nav>
                                                </div>
                                            </div>
                                        </> : <>
                                            <div className="header-button ms-4">
                                                <a onClick={() => {
                                                    this.navLogin();
                                                }}
                                                    className="gt-btn bg-white text-dark">
                                                    <span>Login<i className="fa fa-arrow-right-long"></i></span>
                                                </a>
                                            </div>
                                        </>}
                                        <div className="header__hamburger d-block d-xl-none my-auto">
                                            <div className="sidebar__toggle"><i className="fa fa-bars"></i></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
                <Modal show={isOpen} size="lg">
                    <Modal.Body className="pb-2 pt-2"
                        style={{
                            backgroundColor: '#744587',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                        }}>
                        <span className="pop-close"
                            onClick={() => {
                                this.setState({ isOpen: false });
                                if (intervalId) {
                                    clearInterval(intervalId);
                                    this.setState({ intervalId: null })
                                }
                            }}
                        >X</span>
                        <div className="container text-center p-4">
                            <img src="assets/img/logo_1.png" alt="logo" className="image timer-pop" />
                            <h2 className="py-3 text-center com-soon-tag">Coming Soon</h2>
                            {popDetails != {} && <h5 className="pb-5 timer-pop-text com-soon">
                                The {popMsg} will start on {popDetails["date"]}<sup>{popDetails["pronounce"]}</sup> {popDetails["month"]} {popDetails["year"]} at {popDetails["time"]} noon (IST)
                            </h5>}
                            <div className="countdown-out mt-5">
                                <div className="countdown">
                                    <div><span id="days">{timeLeft.days}</span>
                                        <small>Days</small></div>
                                    <div><span id="hours">{timeLeft.hours}</span>
                                        <small>Hours</small></div>
                                    <div><span id="minutes">{timeLeft.minutes}</span>
                                        <small>Minutes</small></div>
                                    <div><span id="seconds">{timeLeft.seconds}</span>
                                        <small>Seconds</small></div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </>
        )
    }
}

export default withRouter(
    connect(null, { getCmsContent_action, getCartList_action })(NewHeader)
);